import React, { useEffect, useRef, useState } from 'react'
import {  useNavigate } from 'react-router-dom';
import Icon from '../../components/tables/Icon';
import axios from 'axios';
import language from '../../variables/language';
import { DateTime } from  "luxon";
import IconDone from '../../components/icons/IconDone';
import IconWrong from '../../components/icons/IconWrong';
import IconInwork from '../../components/icons/IconInwork';
import IconAccepted from '../../components/icons/IconAccepted';
import ChatComponent from '../../components/websocket/ChatComponent';
import IconMessages from '../../components/icons/IconMessages';

const URL_PATTERN = /(https?:\/\/[^\s]+)/g;

const linkifyText = (text) => {
   if(!text) {
      return text;
   }
   return text.split(URL_PATTERN).map((part, i) =>
      URL_PATTERN.test(part) ? (
         <a key={i} href={part} target='_blank' rel='noreferrer' className='pipe-chat-link' onClick={(e) => e.stopPropagation()}>{part}</a>
      ) : part
   );
}

const formatMessageTime = (dateTime) => {
   if(!dateTime) {
      return '';
   }
   try{
      return DateTime.fromISO(dateTime.replace(/\[.*\]/, ""), { setZone: true }).toFormat("HH:mm");
   }catch(e){
      return '';
   }
}

export default function ConvProgressMenu(props) {
   const navigate = useNavigate();
   const [messages, setMessages] = useState([]);
   const [currentConvProgId, setCurrentConvProgId] = useState();
   const [messagesLoading, setMessagesLoading] = useState(false);
   const chatScrollRef = useRef(null);
   const requestedConvProgId = useRef();

   useEffect(()=> {
      setMessages([])
      setCurrentConvProgId();
      requestedConvProgId.current = undefined;
   },[props.modalState])

   useEffect(() => {
      if(chatScrollRef.current) {
         chatScrollRef.current.scrollTop = chatScrollRef.current.scrollHeight;
      }
   },[messages])

   const openMessages = (e, convProgId) => {
         e.stopPropagation();

         if (currentConvProgId === convProgId) {
            // clicking the already-open conversation again -> collapse it
            setCurrentConvProgId();
            setMessages([]);
            requestedConvProgId.current = undefined;
            return;
         }

         setCurrentConvProgId(convProgId);
         setMessages([]);
         setMessagesLoading(true);
         requestedConvProgId.current = convProgId;
         getMessages(convProgId)
               .then(response => {
                  if(requestedConvProgId.current !== convProgId) {
                     return;
                  }
                  setMessages(response.data)
               })
               .catch(err => {
                  console.log(err);
               })
               .finally(() => {
                  if(requestedConvProgId.current === convProgId) {
                     setMessagesLoading(false);
                  }
               });

   }


   const getMessages = (id) => {

    return  axios.get('/api/messages/byconvprogress/' + id, {
            withCredentials: true});
   }

   const goToMessages = (e,convId) => {
      e.stopPropagation();
      navigate("/messages/byconvprogress/"+convId);
   }

   const userInitial = (props.client && props.client.firstName) ? props.client.firstName.trim().charAt(0).toUpperCase() : 'U';

  return (
    <div className='conv-progress-menu'   >
      <div className='conv-progress-menu-selector'>
         <div className='conv-progress-header'><p className='txt-c'>{language[language.lang]['clients conversations']}
            {Array.isArray(props.stages) && props.stages.length > 0 ? ` (${props.stages.length})` : ''}:</p></div>
         {Array.isArray(props.stages) && props.stages.length > 0 ? (
                  props.stages.map(item => (
                     <div key={item.id}>
                        <div  onClick={(e) => openMessages(e, item.id)}
                        className={'card-selector-conv-progress txt-c' + (item.id === currentConvProgId && (messagesLoading || messages.length > 0) ? ' conv-row-active' : '')}>
                              <div className='conv-row-icon-btn' onClick={(e) => goToMessages(e, item.id)} title={language[language.lang].messages}>
                                 <IconMessages style={{width:14,height:14,margin:0,fill:'var(--lighttext-color)'}} />
                              </div>
                              <span className='conv-row-name'>{item.conversationId.name}</span>
                              <span className='conv-row-date'>{ DateTime.fromISO(item.dAdd, { setZone: true }).toFormat("dd.MM.yyyy")}</span>
                              <span className='conv-row-status' title={item.isFinished == 1 ? language[language.lang].isFinished : language[language.lang].inProgress}>
                              {item.isFinished == 1 ? (
                                    <IconDone fillColor='icon-green' ></IconDone>
                              ) : (
                                    <IconInwork fillColor='icon-yellow' ></IconInwork>
                              ) }
                              </span>
                        </div>
                        {item.id === currentConvProgId ? (
                           <div className='pipe-chat-scroll' ref={chatScrollRef}>
                              {
                                messagesLoading ? (
                                   <div className='pipe-loader'></div>
                                ) :
                                Array.isArray(messages) && messages.length > 0 ? (
                                    messages.map(m => {
                                       const isBot = m.isBot == 1;
                                       const isCorrect = !isBot && m.answerConnector && m.answerConnector.isRight && m.answerConnector.isRight.id === 1;
                                       const isWrong = !isBot && m.answerConnector && m.answerConnector.isRight && m.answerConnector.isRight.id === 2;
                                       return (
                                          <div key={m.id} className={'pipe-chat-row ' + (isBot ? 'pipe-chat-row-bot' : 'pipe-chat-row-user')}>
                                             {isBot ? <div className='pipe-chat-avatar pipe-chat-avatar-bot' title='Bot'>B</div> : ''}
                                             <div className={'pipe-chat-bubble ' + (isBot ? 'pipe-chat-bubble-bot' : 'pipe-chat-bubble-user')
                                                + (isCorrect ? ' pipe-chat-bubble-correct' : '') + (isWrong ? ' pipe-chat-bubble-wrong' : '')}>
                                                <p className='pipe-chat-bubble-text'>{linkifyText(m.text)}</p>
                                                <div className='pipe-chat-bubble-footer'>
                                                   {isCorrect ? <IconAccepted fillColor='icon-green'></IconAccepted> : ''}
                                                   {isWrong ? <IconWrong fillColor='icon-red'></IconWrong> : ''}
                                                   <span className='pipe-chat-bubble-time'>{formatMessageTime(m.dateTime)}</span>
                                                </div>
                                             </div>
                                             {!isBot ? <div className='pipe-chat-avatar pipe-chat-avatar-user' title={props.client && props.client.firstName}>{userInitial}</div> : ''}
                                          </div>
                                       );
                                    })
                                 ) : (
                                    <div className='pipe-conv-empty'>{language[language.lang]['empty list']}</div>
                                 )
                              }
                           </div>
                        ) : ''}

                     </div>
                  ))
               ) : (
                  <div className='pipe-conv-empty empty-list'>{language[language.lang]['empty list']}</div>
            )}

      </div>




    </div>
  )
}
